<app-custom-dropdown
  [isTopOriented]="isTopOriented"
  data-automation-id="search-res-number-dropdown"
  [selectedOption]="value"
  [focus$]="focus$"
  [aria-label]="'resultsPerPage' | translate"
  search-res-number-dropdown
  (change)="onDropdownChange($event)"
>
  <span custom-dropdown-label data-automation-id="search-res-number-label" translate>resultsPerPage</span>
  <app-custom-dropdown-option
    data-automation-id="search-res-number-option"
    [value]="10"
    [id]="10"
  > 10 </app-custom-dropdown-option>
  <app-custom-dropdown-option
    data-automation-id="search-res-number-option"
    [value]="20"
    [id]="20"
  > 20 </app-custom-dropdown-option>
  <app-custom-dropdown-option
    data-automation-id="search-res-number-option"
    [value]="40"
    [id]="40"
  > 40 </app-custom-dropdown-option>
</app-custom-dropdown>
